import { Component, TemplateRef } from "@angular/core";
import { ProfileService } from "../../../../services";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { ToasterService } from "angular2-toaster";
import { TokenInterceptor } from "../../../../helpers";
import { AppService } from "app/services/app.service";

@Component({
  selector: "app-reset-pwd",
  templateUrl: "./app-reset-pwd.component.html",
  styleUrls: ["./app-reset-pwd.component.scss"],
  providers: [ProfileService, TokenInterceptor],
})
export class AppResetPwdComponent {
  public resetPasswordForm: FormGroup;
  public loading: boolean;
  public activated: boolean;
  public errorMessage: "";
  modalRef: BsModalRef;

  constructor(
    fb: FormBuilder,
    private profileService: ProfileService,
    private modalService: BsModalService,
    private tokenInterceptor: TokenInterceptor,
    private toasterService: ToasterService,
    private appService: AppService
  ) {
    this.activated = false;
    this.resetPasswordForm = fb.group({
      oldPassword: ["", [Validators.required, Validators.minLength(6)]],
      newPassword: ["", [Validators.required, Validators.minLength(6)]],
      newPasswordRepeat: ["", [Validators.required, Validators.minLength(6)]],
    });
  }

  checkPasswords() {
    return (
      this.resetPasswordForm.get("newPassword").value ===
      this.resetPasswordForm.get("newPasswordRepeat").value
    );
  }

  toggleModal(_template: TemplateRef<any>) {
    this.resetPasswordForm.reset();
    this.errorMessage = "";
    this.loading = false;
    this.modalRef = this.modalService.show(_template, {
      ignoreBackdropClick: true,
    });
  }

  submit() {
    this.loading = true;
    this.profileService
      .resetPassword(
        this.resetPasswordForm.getRawValue().oldPassword,
        this.resetPasswordForm.getRawValue().newPassword,
        this.resetPasswordForm.getRawValue().newPasswordRepeat
      )
      .subscribe(
        (response) => {
          this.errorMessage = "";
          this.loading = false;
          this.resetPasswordForm.reset();
          localStorage.setItem("token", response["token"]);
          this.appService.setCookie("tutored-employer", response["token"], 365);
          this.tokenInterceptor.refreshToken(response["token"]);
          this.modalRef.hide();
          this.toasterService.pop("success", "Success", "Password updated");
        },
        (reject) => {
          this.loading = false;
          this.errorMessage = reject.error.message;
        }
      );
  }
}
